import useWritePreCart from './useWritePreCart';

const useReadProductCustomWording = (cartProduct = null) => {
  const { preCartData } = useWritePreCart();
  const { product: preCartProduct } = preCartData;

  const product = cartProduct ?? preCartProduct;

  return {
    participant: product?.be_participant_wording ?? null,
    main_price: product?.be_main_price_wording ?? null,
  };
};

export default useReadProductCustomWording;
